<script>
  import {
    ShoppingCartIcon,
  } from 'vue-feather-icons'
  import {
    supplierServiceMethods,
    statusMethods,
    windowsComputed,
  } from '@state/helpers'
  import {
    PROJECTS_ADMIN,
  } from '@utils/permissions'
  import {
    msgBoxOKPopup
  } from '@utils/confirmBox';
  import _startCase from 'lodash/startCase'


  export default {
    components: {
      ShoppingCartIcon,
    },
    props: {
      supplierId: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        PROJECTS_ADMIN: PROJECTS_ADMIN,
        fields: [
          { key: 'selected', label: '', sortable: false, cull: 0 },
          { key: 'title', label: 'Name', sortable: true, sortDirection: 'desc', cull: 0 },
          { key: 'type', label: 'Type', hideOnDetail: true, sortable: true, sortDirection: 'desc', cull: 1240 },
          { key: 'price', label: 'Price', hideOnDetail: true, sortable: true, cull: 999 },
          { key: 'status', label: 'Status', sortable: true, class: 'status-cell', cull: 550 },
          { key: 'actions', label: 'Actions', class: 'action-groups', cull: 850 },
        ],
        filter: {},
        filtersHidden: true,
        addTimeout: null
      }
    },
    computed:{
      ...windowsComputed,
      defaultFilters(){
        return {
          orderBy: 'name',
          sortedBy: 'asc',
        }
      }
    },
    mounted(){
      if (!this.isTablet){
        this.filtersHidden = false
      }
    },
    methods: {
      ...supplierServiceMethods,
      ...statusMethods,
      msgBoxOKPopup,
      transformData (row) {
        const cost = row.prices.find(price => price.key === 'cost')
        const costPrice = cost ? cost.amount : 0
        return {
          ...row,
          title: row.name,
          status: row.status,
          price: `$${costPrice}`,
          type: _startCase(row.type),
        }
      },
      tryToFilterData (filter) {
        this.filter = {
          ...this.filter,
          ...filter,
          page: 1,
        }
      },
      getData (params = {}) {
        if(! params.status){
          params.statuses = 'active'
        }
        return this.getServices({
          supplierId: this.supplierId,
          params,
        })
      },
      async tryToAddSelectedItems () {
        if (!this.$refs.listing.items || !this.$refs.listing.items.data) {
          return this.msgBoxOKPopup(
            'Please select at least one item',
            { hideHeader: true }
          )
        }
        const selectedItems = this.$refs.listing.items.data.filter(item => item.selected)
        if (!selectedItems.length) {
          return this.msgBoxOKPopup(
            'Please select at least one item',
            { hideHeader: true }
          )
        }
        clearTimeout(this.addTimeout)
        this.addTimeout = setTimeout(() => {
          this.$emit('add-cart', selectedItems, true)
        }, 300)
      },
      tryToAddItem (item) {
        clearTimeout(this.addTimeout)
        this.addTimeout = setTimeout(() => {
          this.$emit('add-cart', [item], false)
        }, 300)
      },
      toggleFilters(event){
        this.$set(this,'filtersHidden', event)
      },
    },
  }
</script>

<template>
  <div>
    <div class="page-customes sub-page-wrapper sub-page pt-3 tw-pr-4 lg:tw-pr-0">
      <div class="sub-page-content has-filter-panel tw-flex tw-flex-col lg:tw-flex-row-reverse">
        <BaseFiltersWrapper
          :filters-hidden="filtersHidden">
          <template v-slot:search>
            <BaseListFilters
              :admin-permission="PROJECTS_ADMIN"
              inside-modal
              @toggle-filters="toggleFilters"
              @filter="tryToFilterData"
            />
          </template>
        </BaseFiltersWrapper>
        <div class="grid-listing staf-list-content">
          <BaseListTable
            ref="listing"
            hide-heading
            :stacked-tier="false"
            :transform-data="transformData"
            :get-data="getData"
            :fields="fields"
            :filter="filter"
            :hide-create-action="true"
            :default-filtering="defaultFilters"
          >
            <template v-slot:thead-top>
              <b-tr>
                <b-th :colspan="fields.length" class="bd-bottom">
                  <BaseListTableHeader>
                    <template v-slot:drop-down-elements>
                      <slot name="other-actions-selected-items"></slot>
                      <FabricDropdownElement @click="tryToAddSelectedItems">Add selected items</FabricDropdownElement>
                    </template>
                  </BaseListTableHeader>
                </b-th>
              </b-tr>
            </template>
            <template v-slot:actions="row">
              <div class="tw-flex align-items-center justify-content-center">
                <button
                  type="button"
                  class="btn-secondary button-transparent edit pd-0 ml-2 mr-2"
                  @click="tryToAddItem(row.item)"
                >
                  <ShoppingCartIcon size="1.5x" />
                </button>
              </div>
            </template>
            <template v-slot:row-details="row">
              <div class="position-relative">
                <article class="card-body tw-flex">
                  <div class="tw-w-full">
                    <ul>
                      <BaseDetailsListItem
                        v-if="row.item.name"
                        name="Name"
                        :value="row.item.name"
                      />
                      <BaseDetailsListItem
                        v-if="row.item.description"
                        name="Description"
                        :value="row.item.description"
                      />
                      <BaseDetailsListItem
                        v-if="row.item.price"
                        name="Price"
                        :value="row.item.price"
                      />
                      <BaseDetailsListStatus
                        v-if="row.item.status"
                        name="Status:"
                        :value="row.item.status"
                      />
                    </ul>
                  </div>
                </article>
              </div>
            </template>
          </BaseListTable>
        </div>
      </div>
    </div>
  </div>
</template>
